import {
  PlayerImage,
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import { AddIconButton } from '@library/components/buttons';

export const StreakAddProjectionRow = ({
  imageUrl = '',
  name,
  onAddProjection,
  subheader,
  statType,
  lineScore,
  gameInfo
}: {
  imageUrl?: string;
  name: string;
  onAddProjection: VoidFunction;
  subheader: string;
  statType: string;
  lineScore: string | number;
  gameInfo: string;
}) => {
  return (
    <div className="flex h-[49px] w-full items-center justify-between self-stretch">
      <PlayerProfile
        className="flex min-w-48 max-w-48 items-center gap-4"
        imageUrl={imageUrl}
        name={name}
        subheader={subheader}
      >
        <PlayerImage className="bg-soFresh-120 size-[49px] rounded-lg" />

        <div className="border-soFresh-110 flex h-10 flex-col items-start justify-start gap-2">
          <PlayerName className="font-heebo text-soClean-100 text-center text-sm font-medium leading-tight tracking-tight" />
          <PlayerSubheader className="text-soClean-170 font-heebo text-xs font-medium leading-5 tracking-tight" />
        </div>
      </PlayerProfile>
      <div className="flex flex-col justify-between">
        <div className="text-soClean-170 ml-2 w-32 text-xs">
          <span className="font-heebo font-medium leading-tight tracking-tight">
            {statType}
          </span>
          &nbsp;•&nbsp;
          <span className="font-heebo font-light leading-tight tracking-tight">
            {lineScore}
          </span>
        </div>
        <div className="text-soClean-170 ml-2 w-32 text-xs">
          <span className="font-heebo font-medium leading-tight tracking-tight">
            {gameInfo}
          </span>
        </div>
      </div>
      <AddIconButton onClick={onAddProjection} />
    </div>
  );
};
